module.exports = __webpack_public_path__ + "img/chamber-logo.16f8342f.jpg";